import { IAdvancedRichText } from '../../../../../inputs';
import { IBaseWidget } from '../../../IBaseWidget';
import type { WidgetType } from '../../../Widget';
import type { IInputWidget } from '../IInputWidget';

/**
 * Input Booleano (Checkbox)
 */
export interface IBooleanWidget extends IInputWidget {
  type: WidgetType.Boolean;
  // value: string;
  text?: IAdvancedRichText; // testo laterale al checkbox
}

export function hasWidgetText<W extends IBaseWidget>(
  widget: W & { text?: IAdvancedRichText },
): widget is W & { text: IAdvancedRichText } {
  return 'text' in widget;
}
